import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setTitle('Lagerfächer anlegen')
        .setRoute('bin_create_bins'),
];
